import { MatDialogConfig } from "@angular/material/dialog";

export const dialogDefaultOptions: MatDialogConfig = {
  ...new MatDialogConfig(),
  maxWidth: "100vw",
  maxHeight: "100vh"
};
